module.exports = __webpack_public_path__ + "media/images/br-139516c256b54d0e93e3f216c8e9b405.png";